"use strict";

var _slicedToArray = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var reselect_1 = require("reselect");

var scenario_state_1 = require("./scenario.state");

var scenario_utils_1 = require("./scenario.utils");

var selectScenario = function selectScenario(state) {
  return state.scenario;
};
/*====================================
  ScenarioNode
=====================================*/

/* nodeMap */


exports.selectNodeMap = reselect_1.createSelector(selectScenario, function (scenario) {
  return scenario.nodeMap;
});
/* node */

exports.selectCurrentNodeId = reselect_1.createSelector(selectScenario, function (scenario) {
  return scenario.currentNodeId;
});
exports.selectCurrentNode = reselect_1.createSelector([exports.selectNodeMap, exports.selectCurrentNodeId], function (nodeMap, currentNodeId) {
  return nodeMap[currentNodeId];
});
exports.selectPreviewAction = reselect_1.createSelector(selectScenario, function (scenario) {
  return scenario.previewAction;
});
exports.selectParentNodeId = reselect_1.createSelector(exports.selectCurrentNode, function (currentNode) {
  return !!currentNode ? currentNode.parentId : undefined;
});
exports.selectGreetingScenarioNode = reselect_1.createSelector(exports.selectNodeMap, function (nodeMap) {
  return nodeMap[scenario_state_1.GREETING_SCENARIO_NODE_ID];
});
exports.selectParentNode = reselect_1.createSelector([exports.selectCurrentNode, exports.selectNodeMap], function (currentNode, nodeMap) {
  if (!currentNode || !currentNode.parentId) return;
  return nodeMap[currentNode.parentId];
});

exports.getSelectNode = function (nodeId) {
  return reselect_1.createSelector(exports.selectNodeMap, function (nodeMap) {
    return nodeMap[nodeId];
  });
};
/* option */


exports.getSelectOption = function (nodeId, optionIndex) {
  return reselect_1.createSelector(exports.getSelectNode(nodeId), function (node) {
    var option = node && node.options[optionIndex];
    return option;
  });
};
/*====================================
  Keyword
=====================================*/


exports.selectKeywordsMap = reselect_1.createSelector(selectScenario, function (scenario) {
  return scenario.keywordsMap;
});
exports.selectSearchKeywords = reselect_1.createSelector(exports.selectKeywordsMap, function (keywordsMap) {
  return Object.entries(keywordsMap).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        nodeId = _ref2[0],
        keywords = _ref2[1];

    return keywords.map(function (keyword) {
      return {
        actionId: nodeId,
        actionType: scenario_state_1.ActionType.Id,
        label: keyword
      };
    });
  }).flat();
});
exports.selectCurrentKeywords = reselect_1.createSelector([exports.selectKeywordsMap, exports.selectCurrentNodeId], function (keywordsMap, currentNodeId) {
  return keywordsMap[currentNodeId] || [];
});
/*====================================
  Variable
=====================================*/

exports.selectVariables = reselect_1.createSelector(selectScenario, function (scenario) {
  return scenario.variables;
});
exports.selectUrlVariables = reselect_1.createSelector(exports.selectVariables, function (variables) {
  return variables.filter(function (_ref3) {
    var type = _ref3.type;
    return type === scenario_state_1.VariableType.Url;
  });
});

exports.getSelectUrlByKey = function (key) {
  return reselect_1.createSelector(exports.selectUrlVariables, function (urlVariables) {
    var urlVariable = urlVariables.find(function (urlVariable) {
      return urlVariable.key === key;
    });
    return urlVariable ? urlVariable.value : undefined;
  });
};
/* PARESED
 *--------------------------------*/


exports.getSelectParsedNode = function (nodeId) {
  return reselect_1.createSelector([exports.selectNodeMap, exports.selectVariables], function (nodeMap, variables) {
    var node = nodeMap[nodeId];
    if (!node) return;
    return scenario_utils_1.parseNode(node, variables);
  });
};

exports.selectParsedParentNode = reselect_1.createSelector([exports.selectCurrentNode, exports.selectNodeMap, exports.selectVariables], function (currentNode, nodeMap, variables) {
  if (!currentNode || !currentNode.parentId) return;
  var parentNode = nodeMap[currentNode.parentId];
  if (!parentNode) return;
  return scenario_utils_1.parseNode(parentNode, variables);
});
/*====================================
  Design
=====================================*/

exports.selectDesign = reselect_1.createSelector(selectScenario, function (scenario) {
  return scenario.design;
});
/*====================================
  DEPLOY SCENARIO
=====================================*/

exports.selectParsedNodeMap = reselect_1.createSelector([exports.selectNodeMap, exports.selectVariables], function (nodeMap, variables) {
  return scenario_utils_1.parseNodeMap(nodeMap, variables);
});
exports.selectIsValidNodeMap = reselect_1.createSelector(exports.selectParsedNodeMap, function (parsedNodeMap) {
  return scenario_utils_1.validateNodeMap(parsedNodeMap, scenario_state_1.GREETING_SCENARIO_NODE_ID);
});